// extracted by mini-css-extract-plugin
export default {"tabs":"DUSanVNRCYLPn3EbCYzQ","content":"TUKzpQIBqTTFHUWQHBEQ","contentInside":"Bcxge1dn7VLq8ur_mv9q","panels":"miqJ2EIMa6_9jFkDqenL","placeHolderShimmer":"i0MtPT44LRYD3b_qpvwY"};